import React from 'react';
import PropTypes from 'prop-types';
import { EmailFieldFormatter } from '../FieldFormatter/EmailFieldFormatter';
import { PhoneFieldFormatter } from '../PhoneFieldFormatter/PhoneFieldFormatter';

export const EmailPhoneInput = ({
  name,
  emailValue,
  phoneValue,
  emailCallback,
  phoneCallback
}) => {

  return (
    <div className="sui-grid sui-grid-cols-12 sui-gap-4">
      <div className="sui-col-span-12 md:sui-col-span-6">
        <EmailFieldFormatter
          name={name}
          callback={emailCallback}
          value={emailValue}
        />
      </div>
      <div className="sui-col-span-12 md:sui-col-span-6">
        <PhoneFieldFormatter
          name={name}
          callback={phoneCallback}
          value={phoneValue}
        />
      </div>
    </div>
  );
};

EmailPhoneInput.displayName = 'emailPhoneInput';

EmailPhoneInput.propTypes = {
  emailValue: PropTypes.string.isRequired,
  phoneValue: PropTypes.string.isRequired,
  emailCallback: PropTypes.func.isRequired,
  phoneCallback: PropTypes.func.isRequired,
  name: PropTypes.string
};

EmailPhoneInput.defaultProps = {
  name: 'input'
};
